$(document).ready(function () {
   let menuRel = "";
   $('.new_header .bt .lt .lk').hover(function () {
     console.log('hovered');
      menuRel = $(this).attr('rel');
      $('.new_header .mn').show();
      $('.new_header .mn1, .new_header .mn2, .new_header .mn3').hide();
      $('.new_header .' + menuRel).show();
      $('.new_header .bt .lt .lk').removeClass('active');
      $(this).addClass('active');
   }, function () {
      $('.new_header .mn').hide();
      $('.new_header .bt .lt .lk').removeClass('active');
   })

   $('.new_header .mn').hover(function () {
      $(this).show();
      $('.new_header .bt .lt .lk').removeClass('active');
      $('.new_header .bt .lt .lk[rel="' + menuRel + '"]').addClass('active');
   }, function () {
      $(this).hide();
      $('.new_header .bt .lt .lk').removeClass('active');
   });

   $('.new_header .btn_menu').click(function () {
      if ($(this).hasClass('active')) {
         $('.new_header .btn_menu').removeClass('active');
         $('.new_header .mob_mn').hide();
      } else {
         $('.new_header .btn_menu').removeClass('active');
         $(this).addClass('active');
         $('.new_header .mob_mn').show();
      }
   });

   $('.section-nine .accordion').click(function () {
      $('.section-nine .acdn-content').stop(true).slideUp(500);
      if ($(this).hasClass('accordion-open')) {
         $('.section-nine .accordion').removeClass('accordion-open');
         $(this).next('.acdn-content').stop(true).slideUp(500);
      } else {
         $('.section-nine .accordion').removeClass('accordion-open');
         $(this).addClass('accordion-open');
         $(this).next('.acdn-content').stop(true).slideDown(500);
      }
   });
  
});